import * as api from '../../../../../api/masters/users/role/roleApi';
import {
  FETCH_ROLES_REQUEST,
  FETCH_ROLES_SUCCESS,
  FETCH_ROLES_FAILURE,
  ADD_ROLE_SUCCESS,
  UPDATE_ROLE_SUCCESS,
  DELETE_ROLE_SUCCESS,
  SET_EDITING_ROLE,
  CLEAR_EDITING_ROLE
} from '../../../../types/masters/users/role/roleTypes';

export const fetchRoles = () => async (dispatch) => {
  dispatch({ type: FETCH_ROLES_REQUEST });
  try {
    const roles = await api.fetchRoles();
    dispatch({ type: FETCH_ROLES_SUCCESS, payload: roles });
  } catch (error) {
    dispatch({ type: FETCH_ROLES_FAILURE, error: error.message });
  }
};

export const addRole = (role) => async (dispatch) => {
  const newRole = await api.addRole(role);
  dispatch({ type: ADD_ROLE_SUCCESS, payload: newRole });
};

export const updateRole = ({ id, role }) => async (dispatch) => {
  const updated = await api.updateRole(id, role);
  dispatch({ type: UPDATE_ROLE_SUCCESS, payload: updated });
};

export const deleteRole = (id) => async (dispatch) => {
  await api.deleteRole(id);
  dispatch({ type: DELETE_ROLE_SUCCESS, payload: id });
};

export const setEditingRole = (role) => ({ type: SET_EDITING_ROLE, payload: role });
export const clearEditingRole = () => ({ type: CLEAR_EDITING_ROLE }); 